import {
  CFormCheck,
  CSpinner,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useToast } from "../../hooks/useToast";
import { useCookie } from "../../hooks/useCookie";
import apiService from "../../service/apiService";
import { DELETE_ACTIONS } from "../../config/constants";
import { general } from "../../locales/general";
import { colors } from "../../config/theme";
import DeleteIcon from "../../components/icons/DeleteIcon";
import PromptModal from "../../components/modals/PromptModal";

function TableBodyRowContent({
  Inspector,
  deletedList,
}: {
  Inspector: Inspector;
  deletedList: React.Dispatch<BulkDeleteActions>;
}) {
  const [isChecked, setIsChecked] = useState(false);
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();
  const [showModal, setShowModal] = useState(false);

  const deleteInspector = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`inspectors/${id}`, token);
  });

  useEffect(() => {
    if (isChecked) {
      deletedList({ type: DELETE_ACTIONS.ADD, id: Inspector.id });
    } else {
      deletedList({ type: DELETE_ACTIONS.REMOVE, id: Inspector.id });
    }
  }, [deletedList, isChecked, Inspector.id]);

  const removeInspector = () => {
    deleteInspector.mutate(Inspector.id, {
      onError(error) {
        console.log(error);
        toastError(general.fr.message.operationFailed);
      },
      onSuccess() {
        toastSuccess(general.fr.message.inspectorDeleted);
        queryClient.invalidateQueries("getAllInspector");
      },
    });
  };

  return (
    <CTableRow
      style={{
        borderLeft: isChecked ? `3px solid ${colors.primary}` : "",
        width: "100%",
        position: "relative",
      }}
    >
      <CTableDataCell className="p-3 text-sm">
        <CFormCheck
          id="flexCheckDefault"
          label=""
          defaultChecked={isChecked}
          onChange={(e) => setIsChecked(e.target.checked)}
          color={colors.yellow}
        />
        <span className="ms-2">{Inspector?.fullName}</span>
      </CTableDataCell>
      <CTableDataCell className="p-3 text-sm">
        {Inspector?.email}
      </CTableDataCell>

      <CTableDataCell className="p-3 text-capitalize text-sm">
        {Inspector?.phone}
      </CTableDataCell>

      <CTableDataCell className="p-3 text-capitalize text-sm">
        {Inspector?.inspectorForPlace?.name}
      </CTableDataCell>

      <CTableDataCell className="p-3">
        <button
          className="outline-none border-0 bg-transparent"
          onClick={() => setShowModal(true)}
        >
          {deleteInspector.isLoading ? (
            <CSpinner size="sm" />
          ) : (
            <DeleteIcon
              width="20"
              height="20"
              fill={colors.primary}
              className="ms-2"
            />
          )}
        </button>
      </CTableDataCell>
      <PromptModal
        open={showModal}
        onAccept={() => removeInspector()}
        onClose={() => setShowModal(false)}
      />
    </CTableRow>
  );
}

interface TableProps {
  Inspectors: Inspector[];
  InspectorsTableToBeDeleted: React.Dispatch<BulkDeleteActions>;
}

export default function InspectorsTable({
  Inspectors,
  InspectorsTableToBeDeleted,
}: TableProps) {
  return (
    <div className="mt-3">
      <CTable>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col">Nom complet</CTableHeaderCell>
            <CTableHeaderCell scope="col">Email</CTableHeaderCell>
            <CTableHeaderCell scope="col">Téléphone</CTableHeaderCell>
            <CTableHeaderCell scope="col">Établissement</CTableHeaderCell>
            <CTableHeaderCell scope="col"></CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {Inspectors?.map((Inspector) => (
            <TableBodyRowContent
              Inspector={Inspector}
              key={Inspector?.id}
              deletedList={InspectorsTableToBeDeleted}
            />
          ))}{" "}
        </CTableBody>
      </CTable>
    </div>
  );
}
